// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2X_ch","table--header":"styles_table--header__2dZfw","table--cell":"styles_table--cell__IZwkc","content--status":"styles_content--status__QQagq"};